import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ParsingFormat } from '@models/parsing-formats/ParsingFormat';
import { nonNumeralConverter } from '@models/parsing-formats/farsiNumeralConverter';
import { NT_NOUNS, NT_VERBS, OT_NOUNS, OT_VERBS, SimpleStringLookup } from '@models/parsing-formats/ParsingFormatCombinations';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { OTVerboseEnglish } from '@models/parsing-formats/OTVerboseParsingFormatStrings';
import { NTVerboseParsingFormat } from '@models/parsing-formats/NTVerboseParsingFormat';
import { NTVerboseEnglish } from '@models/parsing-formats/NTVerboseParsingFormatStrings';
import { OTVerboseParsingFormat } from '@models/parsing-formats/OTVerboseParsingFormat';
import { PublicationGreekWordElement } from '@models/publication/PublicationGreekWordElement';
import { PublicationHebrewWordElement } from '@models/publication/PublicationHebrewWordElement';

@Component({
  selector: 'app-parsing-test-display',
  imports: [MatTableModule, MatPaginatorModule],
  templateUrl: './parsing-test-display.component.html',
  styleUrl: './parsing-test-display.component.scss'
})
export class ParsingTestDisplayComponent implements OnInit, AfterViewInit {
  @Input() parsingFormat!: ParsingFormat;
  @Input() type!: 'noun' | 'verb';
  rows: SimpleStringLookup[] = [];
  columnsToDisplay = ['raw', 'result'];
  dataSource: MatTableDataSource<SimpleStringLookup> = new MatTableDataSource<SimpleStringLookup>(this.rows);
  rawParsingFormat!: ParsingFormat;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit(): void {
    const canon = this.parsingFormat.canon;
    if (canon === "NT") {
      this.rawParsingFormat = new NTVerboseParsingFormat('dummy', 'nt-verbose', nonNumeralConverter, NTVerboseEnglish);
    } else if (canon === "OT") {
      this.rawParsingFormat = new OTVerboseParsingFormat('dummy', 'ot-verbose', nonNumeralConverter, OTVerboseEnglish);
    }

    if (this.type === 'noun') {
      this.rows = this.nounCombinations;
      this.dataSource = new MatTableDataSource(this.rows);
    } else if (this.type === 'verb') {
      this.rows = this.verbCombinations;
      this.dataSource = new MatTableDataSource(this.rows);
    } else {
      throw new Error("Unknown type: " + this.type);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }


  get verbCombinations(): SimpleStringLookup[] {
    const canon = this.parsingFormat.canon;
    if (canon == "NT") {
      return NT_VERBS;
    } else if (canon == "OT") {
      return OT_VERBS;
    } else {
      throw new Error("Unknown canon: " + canon);
    }
  }


  get nounCombinations(): SimpleStringLookup[] {
    const canon = this.parsingFormat.canon;
    if (canon == "NT") {
      return NT_NOUNS;
    } else if (canon == "OT") {
      return OT_NOUNS;
    } else {
      throw new Error("Unknown canon: " + canon);
    }
  }

  parsing(row: SimpleStringLookup): string {
    const castRow = row as unknown as PublicationGreekWordElement | PublicationHebrewWordElement;
    if (this.type === 'noun') {
      return this.parsingFormat.nounParsingString(castRow);
    } else if (this.type === 'verb') {
      return this.parsingFormat.verbParsingString(castRow);
    } else {
      throw new Error("Unknown type: " + this.type);
    }
  }

  rawFormat(row: SimpleStringLookup): string {
    const castRow = row as unknown as PublicationGreekWordElement | PublicationHebrewWordElement;
    if (this.type === 'noun') {
      return this.rawParsingFormat.nounParsingString(castRow);
    } else if (this.type === 'verb') {
      return this.rawParsingFormat.verbParsingString(castRow);
    } else {
      throw new Error("Unknown type: " + this.type);
    }
  }


}